import MomentUtils from '@date-io/moment';
import { Paper, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardArrowLeft as LeftIcon, KeyboardArrowRight as RightIcon } from '@material-ui/icons';
import { BasePicker, Calendar, MuiPickersUtilsProvider } from 'material-ui-pickers';
import 'moment/locale/fr';
import React from 'react';
import { connect } from 'react-redux';

import { Booking } from '@aps-management/primapp-common';

/* */
const styles = (theme) => ({
  picker: {
    overflow: 'hidden',
    marginTop: theme.spacing.unit * 3,
    // marginLeft: 'auto',
  },
});

/* */
class SetDate extends React.Component {
  /* */
  handleDateChange = (day) => {
    this.props.setDate(day.format('YYYY-MM-DD'));
  };

  /* */
  shouldDisableDate = (day) => {
    const {
      data: { openDates: availableDates },
    } = this.props;
    const formattedDate = day.format('YYYY-MM-DD');

    return !availableDates.includes(formattedDate);
  };

  /* */
  render() {
    const {
      classes,
      data: { openDates: dates },
      search,
    } = this.props;

    const current = new Date(search.date);
    const maxDate = new Date(dates[dates.length - 1]);

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Box m={1} mb={3}>
          <Typography paragraph component='p' variant='h6'>
            {'Quel jour souhaitez-vous consulter ?'}
          </Typography>
          <Paper className={classes.picker}>
            <BasePicker onChange={this.handleDateChange} value={current}>
              {({ date }) => (
                <Calendar
                  date={date}
                  disablePast={true}
                  leftArrowIcon={<LeftIcon />}
                  maxDate={maxDate}
                  onChange={this.handleDateChange}
                  rightArrowIcon={<RightIcon />}
                  shouldDisableDate={this.shouldDisableDate}
                />
              )}
            </BasePicker>
          </Paper>
        </Box>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = ({ bookingData, bookingSearch }) => ({ data: bookingData, search: bookingSearch });

const StyledComponent = withStyles(styles)(SetDate);

export default connect(mapStateToProps, Booking.actions)(StyledComponent);
